import React from 'react';
import { INotification, NotificationAction } from '../../notifications-interfaces';
import { setNotificationsAction } from '../../data/data-service';
import { useDispatch } from 'react-redux';
import { IStoreProps } from '../../index';

interface INonReadIndicator {
    notification: INotification;
    storeProps: IStoreProps;
}

const NonReadIndicator = ({ storeProps, notification }: INonReadIndicator) => {

    const { rootActions } = storeProps;

    const dispatch = useDispatch();

    const onClick = async () => {

        dispatch(
            rootActions.main({
                additionalOpenedMenuNotification: null,
                additionalOpenedMenuStyles: null,
            })
        );

        const response = await setNotificationsAction(
            notification.userNTFGUID,
            NotificationAction.Read,
        );

        if(!response || response.statusCode !== 200) return;

        const count = response.data?.count || 0;
        const notifications = response.data?.notifications || [];

        dispatch(
            rootActions.main({
                count,
                notifications,
            })
        );
    };

    return (
        <>
            {
                !notification.isRead &&
                <button
                    onClick={ onClick }
                    type="button"
                    title="Mark notification as read"
                    aria-label="Mark notification as read"
                    className="rounded-full cursor-pointer"
                    style={{
                        width: '7px',
                        height: '7px',
                        backgroundColor: '#335CFF',
                    }}
                />
            }

            {
                notification.isRead &&
                <div
                    style={{
                        width: '7px',
                        height: '7px',
                        backgroundColor: 'transparent',
                    }}
                />
            }
        </>
    )
};

export default NonReadIndicator;